import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import CreditMemoDetailsInfoTab from './CreditMemoDetailsInfoTab';
import CreditMemoInvoiceViewDescription from './CreditMemoInvoiceViewDescription';
import LineItemCreditTab from './LineItemCreditTab';
import InvoicePdfPreviewComponent from '../../../Elements/InvoicePdfPreviewComponent';
import GeneralEntryLogFigma from '../../../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../../../Elements/CommentsEntryLogDescription';
import AttachmentsComponent from '../../../Elements/AttachmentsComponent';
import LogComponent from '../../../Elements/LogComponent';

export default class CreditMemoDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  creditMemoId = this.urlParams.get('id');

  componentDidMount() {}

  tabs = [
    { label: 'Information', id: 'info', icon: 'fa-solid fa-info', component: <CreditMemoDetailsInfoTab /> },
    { label: 'Line Items', id: 'lineitems', icon: 'fa-solid fa-file-invoice', component: <LineItemCreditTab /> },
    {
      label: 'Invoice View',
      id: 'invoiceviewreuse',
      icon: 'fa-solid fa-eye',
      component: (
        <InvoicePdfPreviewComponent
          id={this.creditMemoId}
          invoiceDescription={CreditMemoInvoiceViewDescription}
          attachRoleKey='creditmemo_attachpdfbutton'
          excelWordRoleKey='creditmemo_excelwordbutton'
          hideSearchStrip={true}
        />
      ),
    },
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comments',
      component: (
        <GeneralEntryLogFigma
          description={CommentsEntryLogDescription}
          context={{ entityTypeId: 36, entityId: this.creditMemoId }}
        />
      ),
    },
    {
      label: 'Attachments',
      id: 'attachments',
      icon: 'fa-solid fa-paperclip',
      component: (
        <AttachmentsComponent
          entityTypeId={36}
          entityId={this.creditMemoId}
          enableAddNew={true}
        />
      ),
    },
    {
      label: 'Logs',
      id: 'logs',
      icon: 'fa-solid fa-stream',
      component: (
        <LogComponent
          entityType='CreditMemo'
          entityId={this.creditMemoId}
        />
      ),
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
